import AxiosFlexeServeInstance from '../../../service/shared/AxiosFlexeServe';
import Environment from '../../../shared/constants/Environment';
import { SettingAPI, SettingsAllAPI } from './UserSettings.model';

export default class SettingsCalls {
  readonly backendSettingsServiceURL =
    Environment.backendUserSettingsServiceURL;
  constructor(private restClient = AxiosFlexeServeInstance) {}

  async getSetting(settingName: string) {
    const url = `${this.backendSettingsServiceURL}/${settingName}`;
    return this.restClient.get<SettingAPI>(url).catch((error) => {
      if (error.response?.status === 404) {
        return undefined;
      }
      return Promise.reject(error);
    });
  }
  async getAllSetting() {
    const url = `${this.backendSettingsServiceURL}`;
    return this.restClient.get<SettingsAllAPI>(url);
  }

  async setSetting(settingName: string, value: string) {
    const url = `${this.backendSettingsServiceURL}/${settingName}`;
    const headers = {
      'Content-Type': 'text/plain',
    };
    return this.restClient.put<void>(url, value, { headers });
  }

  async deleteSetting(settingName: string) {
    const url = `${this.backendSettingsServiceURL}/${settingName}`;
    return this.restClient.delete<void>(url);
  }
}
